import { Context } from '@nuxt/types'

export default (context: Context) => {
  if (context.route.name === 'top') {
    return context.redirect('/')
  }

  if (context.route.name === 'batch-menu') {
    return context.redirect('/batch-menu/bibliography-register')
  }
}
